import React, { Component } from 'react';
import styles from './Dashboard.module.css';
import { Topbar } from '../../components/Topbar';
import { Sidebar } from '../../components/Sidebar';
import { getLang } from '../../i18n/i18n';

import UserModule from './modules/UserModule';
import InvalidModule from './modules/InvalidModule';
import DashboardModule from './modules/DashboardModule';
import CommerceModule from './modules/CommerceModule';
import DocumentModule from './modules/DocumentModule';
import ContentModule from './modules/ContentModule';
import EmailModule from './modules/EmailModule';
import FeedbackModule from './modules/FeedbackModule';
import AuditModule from './modules/AuditModule';
import PlotModule from './modules/plot/PlotModule';

import dashboardIcon from './icons/ic_dashboard.svg';
import contentIcon from './icons/ic_news.svg';
import userIcon from './icons/ic_users.svg';
import commerceIcon from './icons/ic_commerce.svg';
import documentIcon from './icons/ic_documents.svg';
import emailIcon from './icons/ic_email.svg';
import feedbackIcon from './icons/ic_feedback.svg';
import auditIcon from './icons/ic_audit.svg';
import mapIcon from './icons/ic_map.svg';

import { LanguageContext } from '../../i18n/LanguageContext';

export class Dashboard extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        if (!localStorage.getItem('lang')) {
            localStorage.setItem('lang', 'es');
        }

        const selectedLanguage = localStorage.getItem('lang');
        const lang = getLang(selectedLanguage);

        let baseModules = [
            {
                id: 'content',
                role: 'content_admin',
                icon: contentIcon,
                class: 'ic-news',
                name: lang['CONTENT']
            },
            {
                id: 'document',
                icon: documentIcon,
                role: 'document_admin',
                class: 'ic-document',
                name: lang['DOCUMENTS']
            },
            {
                id: 'commerce',
                icon: commerceIcon,
                role: 'commerce_admin',
                class: 'ic-commerce',
                name: lang['COMMERCE']
            },
            {
                id: 'user',
                icon: userIcon,
                role: 'user_admin',
                class: 'ic-user',
                name: lang['USERS']
            },
            {
                id: 'email',
                icon: emailIcon,
                role: 'email_admin',
                class: 'ic-email',
                name: lang['EMAIL']
            },
            {
                id: 'feedback',
                icon: feedbackIcon,
                role: 'feedback_admin',
                class: 'ic-feedback',
                name: lang['FEEDBACK']
            },
            {
                id: 'audit',
                icon: auditIcon,
                role: 'audit_admin',
                class: 'ic-audit',
                name: lang['AUDIT']
            },
            {
                id: 'plot',
                icon: mapIcon,
                role: 'content_admin',
                class: 'ic-plot',
                name: lang['PLOT']
            }
        ];
        const meRoles = props.me.roles;
        let modules = baseModules.filter(mod => meRoles
            .includes('super_admin') || meRoles.includes(mod.role));

        // I add the dashboard module
        modules.unshift({
            id: 'dashboard',
            icon: dashboardIcon,
            role: '',
            class: 'ic-news',
            name: lang['HOME']
        });

        modules = modules.map((mod, index) => {
            mod.selected = index === 0;
            return mod;
        });

        this.state = {
            isMenuOpen: true,
            user: JSON.parse(!!localStorage.getItem('me') ?
                localStorage.getItem('me') : '{}'),
            modules: modules,
            moduleName: modules[0].id,
            selectedLanguage: selectedLanguage,
            lang
        }

        this.onClickMenu = this.onClickMenu.bind(this);
        this.onModuleClicked = this.onModuleClicked.bind(this);
        this.onExitClick = this.onExitClick.bind(this);
        this.onLogout = this.onLogout.bind(this);
        this.onLanguageChange = this.onLanguageChange.bind(this);
    }

    onModuleClicked(id) {
        let modules = [];

        // eslint-disable-next-line no-unused-vars
        for (const mod of this.state.modules) {
            if (mod.id === id) {
                mod.selected = true;
            } else {
                mod.selected = false;
            }
            modules.push(mod);
        }

        this.setState({ modules: modules, moduleName: id });
    }

    onLanguageChange(language) {
        localStorage.setItem('lang', language);

        const lang = getLang(language);
        this.setState({
            langName: lang,
            lang: lang,
            modules: this.state.modules.map(mod => {
                switch (mod.id) {
                    case 'dashboard':
                        mod.name = lang['HOME'];
                        break;
                    case 'user':
                        mod.name = lang['USERS'];
                        break;
                    case 'document':
                        mod.name = lang['DOCUMENTS'];
                        break;
                    case 'commerce':
                        mod.name = lang['COMMERCE'];
                        break;
                    case 'content':
                        mod.name = lang['CONTENT'];
                        break;
                    case 'email':
                        mod.name = lang['EMAIL'];
                        break;
                    case 'feedback':
                        mod.name = lang['FEEDBACK'];
                        break;
                    case 'audit':
                        mod.name = lang['AUDIT'];
                        break;
                    case 'plot':
                        mod.name = lang['PLOTS'];
                        break;
                    default: break;
                }

                return mod;
            })
        });
    }

    onClickMenu() {
        this.setState({ isMenuOpen: !this.state.isMenuOpen });
    }

    onExitClick() {
        this.onLogout();
    }

    onLogout() {
        if (!localStorage.getItem('lang')) {
            localStorage.setItem('lang', 'es');
        }

        const lang = Object.assign({}, { lang: localStorage.getItem('lang') });

        localStorage.clear();
        localStorage.setItem('lang', lang.lang);

        this.props.onLogout();
    }

    render() {
        return (
            <div className={styles['app-container']}>
                <LanguageContext.Provider value={this.state.lang}>
                    <Topbar
                        user={this.state.user}
                        selectedLanguage={this.state.selectedLanguage}
                        onLanguageChange={this.onLanguageChange}
                        onExitClick={this.onExitClick}
                        onMenuClick={this.onClickMenu} />
                    <div className={styles['wrapper']}>
                        <Sidebar
                            modules={this.state.modules}
                            selectModule={this.onModuleClicked}
                            isOpen={this.state.isMenuOpen} />
                        <Content
                            moduleName={this.state.moduleName} />
                    </div>
                </LanguageContext.Provider>
            </div>
        )
    }
}

class Content extends Component {
    constructor(props) {
        super(props);
        console.log('Module: ', props.moduleName);
    }

    render() {
        let mod;
        switch (this.props.moduleName) {
            case 'user':
                mod = <UserModule />
                break;
            case 'commerce':
                mod = <CommerceModule />
                break;
            case 'dashboard':
                mod = <DashboardModule />
                break;
            case 'document':
                mod = <DocumentModule />
                break;
            case 'content':
                mod = <ContentModule />
                break;
            case 'email':
                mod = <EmailModule />
                break;
            case 'feedback':
                mod = <FeedbackModule />
                break;
            case 'audit':
                mod = <AuditModule />
                break;
            case 'plot':
                mod = <PlotModule />
                break;
            default:
                mod = <InvalidModule />
        }

        return <div className={styles['content']}>
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className={styles['content']}>
                    {mod}
                </div>
            </nav>
        </div>
    }
}